import ReactDOM from 'react-dom';
import "./assets/css/styles.css"
import "./assets/css/reset.css"
import App from "./components/App";

ReactDOM.render(<App />, document.querySelector(".root"));